var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isEditingAlert || !_vm.isMobile)?_c('div',{staticClass:"step-wrapper"},[_c('div',{staticClass:"step",class:{
      visited: _vm.isVisitedObj[1],
      active: _vm.index === 1,
      disabled: _vm.isEditingAlert && (_vm.isApplyBtnDisabled || _vm.isSubmitBtnDisabled)
    },on:{"click":function($event){return _vm.changeStep(1)}}},[_c('span',[_vm._v(_vm._s(_vm.title)+" trigger")]),_c('span',[_c('fa',{attrs:{"icon":"chevron-right"}})],1)]),_c('div',{staticClass:"step",class:{
      visited: _vm.isVisitedObj[2],
      active: _vm.index === 2,
      disabled:
        (!_vm.isEditingAlert && !_vm.isVisitedObj[2] && _vm.index !== 2) ||
        (_vm.isEditingAlert && (_vm.isApplyBtnDisabled || _vm.isSubmitBtnDisabled))
    },on:{"click":function($event){return _vm.changeStep(2)}}},[_c('span',[_vm._v(_vm._s(_vm.title)+" rule")]),_c('span',[_c('fa',{attrs:{"icon":"chevron-right"}})],1)]),_c('div',{staticClass:"step",class:{
      visited: _vm.isVisitedObj[3],
      active: _vm.index === 3,
      disabled:
        (!_vm.isEditingAlert && !_vm.isVisitedObj[3] && _vm.index !== 3) ||
        (_vm.isEditingAlert && (_vm.isApplyBtnDisabled || _vm.isSubmitBtnDisabled))
    },on:{"click":function($event){return _vm.changeStep(3)}}},[_c('span',[_vm._v(_vm._s(_vm.title)+" action")]),_c('span',[_c('fa',{attrs:{"icon":"chevron-right"}})],1)]),_c('div',{staticClass:"step",class:{
      visited: _vm.isVisitedObj[4],
      active: _vm.index === 4,
      disabled:
        (!_vm.isEditingAlert && !_vm.isVisitedObj[4] && _vm.index !== 4) ||
        (_vm.isEditingAlert && (_vm.isApplyBtnDisabled || _vm.isSubmitBtnDisabled))
    },on:{"click":function($event){return _vm.changeStep(4)}}},[_c('span',[_vm._v(_vm._s(_vm.titleName))]),_c('span',[_c('fa',{attrs:{"icon":"chevron-right"}})],1)])]):_c('div',{staticClass:"tab-step-wrapper"},[_c('div',{staticClass:"tab-step",class:{
      visited: _vm.isVisitedObj[1],
      active: _vm.index === 1,
      disabled: _vm.isEditingAlert && (_vm.isApplyBtnDisabled || _vm.isSubmitBtnDisabled)
    },on:{"click":function($event){return _vm.changeStep(1)}}},[_c('span',[_vm._v("Trigger")])]),_c('div',{staticClass:"tab-step",class:{
      visited: _vm.isVisitedObj[2],
      active: _vm.index === 2,
      disabled:
        (!_vm.isEditingAlert && !_vm.isVisitedObj[2] && _vm.index !== 2) ||
        (_vm.isEditingAlert && (_vm.isApplyBtnDisabled || _vm.isSubmitBtnDisabled))
    },on:{"click":function($event){return _vm.changeStep(2)}}},[_c('span',[_vm._v("Rule")])]),_c('div',{staticClass:"tab-step",class:{
      visited: _vm.isVisitedObj[3],
      active: _vm.index === 3,
      disabled:
        (!_vm.isEditingAlert && !_vm.isVisitedObj[3] && _vm.index !== 3) ||
        (_vm.isEditingAlert && (_vm.isApplyBtnDisabled || _vm.isSubmitBtnDisabled))
    },on:{"click":function($event){return _vm.changeStep(3)}}},[_c('span',[_vm._v("Action")])]),_c('div',{staticClass:"tab-step",class:{
      visited: _vm.isVisitedObj[4],
      active: _vm.index === 4,
      disabled:
        (!_vm.isEditingAlert && !_vm.isVisitedObj[4] && _vm.index !== 4) ||
        (_vm.isEditingAlert && (_vm.isApplyBtnDisabled || _vm.isSubmitBtnDisabled))
    },on:{"click":function($event){return _vm.changeStep(4)}}},[_c('span',[_vm._v("Name")])])])}
var staticRenderFns = []

export { render, staticRenderFns }